var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#7CE0D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.792 13c.028.11.042.291.042.541 0 1.472-.278 2.944-.834 4.417a13.98 13.98 0 0 1-2.375 4c-1 1.194-2.305 2.166-3.916 2.916-1.611.75-3.39 1.125-5.334 1.125-2.444 0-4.68-.652-6.708-1.958.306.028.653.042 1.042.042 2.027 0 3.847-.625 5.458-1.875-.972 0-1.833-.278-2.583-.834a4.52 4.52 0 0 1-1.5-2.166c.277.027.541.041.791.041.39 0 .778-.041 1.167-.125a4.25 4.25 0 0 1-1.792-.833 4.633 4.633 0 0 1-1.25-1.5 4.32 4.32 0 0 1-.458-1.958v-.084a4.118 4.118 0 0 0 1.958.584c-1.305-.89-1.958-2.111-1.958-3.667 0-.778.208-1.514.625-2.208a12.131 12.131 0 0 0 9 4.583 6.068 6.068 0 0 1-.083-1c0-1.194.416-2.222 1.25-3.083.86-.861 1.889-1.292 3.083-1.292 1.278 0 2.347.458 3.208 1.375 1-.194 1.93-.542 2.792-1.042-.333 1.028-.972 1.834-1.917 2.417a9.397 9.397 0 0 0 2.5-.708 9.615 9.615 0 0 1-2.208 2.291z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.eab08928667d56954b2446f82893bb31.svg";
export { ForwardRef as ReactComponent };